import { ThemedText } from '@/components/themed-text';
import { ThemedView } from '@/components/themed-view';

export default function ClubsScreen() {
  return (
    <ThemedView className="flex-1 items-center justify-center px-8">
      <ThemedText type="title" className="mb-2 text-5xl text-gold-dark dark:text-gold">
        Pentarchy
      </ThemedText>
      <ThemedText type="subtitle" className="mb-4">
        Clubs
      </ThemedText>
      <ThemedText type="muted" className="text-center">
        Your clubs will appear here.
      </ThemedText>
    </ThemedView>
  );
}
